import { opportunityService } from '@/services/opportunity.service';
import axios from 'axios';

const initialState = () => ({
  isHealthy: false,
  isCredentialsEntered: false,
  tasks: [],
  documentsDownloaded: {},
  status: {
    error: null,
    pending: false,
    resolved: false,
    rejected: false,
  },
});

const state = initialState();

const actions = {
  setHealthCheck({ commit }, isHealthy) {
    commit('SET_HEALTH_CHECK', isHealthy);
  },
  setIsCredentialsEntered({ commit }, isCredentialsEntered) {
    commit('SET_IS_CREDENTIALS_ENTERED', isCredentialsEntered);
  },
  setTasks({ commit }, tasks) {
    commit('SET_TASKS', tasks);
  },
  setDocumentsDownloaded({ commit }, { opportunityId, downloadedDocuments, failedDocuments }) {
    commit('SET_DOCUMENTS_DOWNLOADED', { opportunityId, downloadedDocuments, failedDocuments });
  },
  refreshOpportunity({ commit, rootState }, opportunityId) {
    return opportunityService.getOpportunity({ id: opportunityId }).then((opportunity) => {
      commit('opportunities/EDIT_OPPORTUNITY_SUCCESS', opportunity, { root: true });

      if (rootState.opportunity.opportunity && rootState.opportunity.opportunity.id === opportunityId) {
        commit('opportunity/SUCCESS', opportunity, { root: true });
      }

      return opportunity;
    });
  },
};

const mutations = {
  SET_HEALTH_CHECK(state, isHealthy) {
    state.isHealthy = isHealthy;
  },
  SET_IS_CREDENTIALS_ENTERED(state, isCredentialsEntered) {
    state.isCredentialsEntered = isCredentialsEntered;
  },
  SET_TASKS(state, tasks) {
    state.tasks = tasks;
  },
  SET_DOCUMENTS_DOWNLOADED(state, { opportunityId, downloadedDocuments, failedDocuments }) {
    state.documentsDownloaded = {
      ...state.documentsDownloaded,
      [opportunityId]: { downloadedDocuments, failedDocuments },
    };
  },
  ERROR(state, error) {
    state.status = {
      ...state.status,
      pending: false,
      rejected: true,
      error: error,
    };
  },
};

const getters = {
  isHealthy: (state) => state.isHealthy,
  isCredentialsEntered: (state) => state.isCredentialsEntered,
  tasks: (state) => state.tasks,
  documentsDownloaded: (state) => state.documentsDownloaded,

  // status
  error: (state) => state.status.error,
  pending: (state) => state.status.pending,
  rejected: (state) => state.status.rejected,
  resolved: (state) => state.status.resolved,
};

export const chromeExtension = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
